import { cn } from '@cocoonspace/ui/lib/utils'
import { CircleMinusIcon, CirclePlusIcon } from 'lucide-react'

export const QuantityInput = ({
	value,
	min,
	max,
	onQtyChange,
	readOnly,
	buttonsClassName,
	iconClassName,
	...props
}: {
	min?: number
	max?: number
	readOnly?: boolean
	value: number
	onQtyChange?: (value: number) => void
	buttonsClassName?: string
	iconClassName?: string
} & React.DetailedHTMLProps<
	React.HTMLAttributes<HTMLDivElement>,
	HTMLDivElement
>) => (
	<div
		{...props}
		className={cn('flex flex-row items-center gap-x-1.5', props.className)}
		data-testid='qty-input'
	>
		{!readOnly && (
			<button
				className={cn(
					'flex items-center justify-center disabled:opacity-20',
					buttonsClassName,
				)}
				data-testid='decrement-btn'
				disabled={value === min}
				onClick={() => onQtyChange?.(value - 1)}
				type='button'
			>
				<CircleMinusIcon
					className={cn(iconClassName)}
					size={18}
				/>
			</button>
		)}

		{value}

		{!readOnly && (
			<button
				className={cn(
					'flex items-center justify-center disabled:opacity-20',
					buttonsClassName,
				)}
				data-testid='increment-btn'
				disabled={max !== undefined && value >= max}
				onClick={() => onQtyChange?.(value + 1)}
				type='button'
			>
				<CirclePlusIcon
					className={cn('text-sm', iconClassName)}
					size={18}
				/>
			</button>
		)}
	</div>
)
